<template>
  <div class="page">
    <el-table stripe :data="tableData" border
              style="width: 100%" height="100%" size="mini" @sort-change="sortChange">
      <el-table-column type="index"
                       :width="pagination.endIndex >= 1000 ? 80:50" align="center"
                       :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column prop="code" label="code" align="left" width="90" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.code">{{ scope.row.code }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="category" label="异常类别" align="left" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.category">{{ scope.row.category }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="name"
          label="产品类别"
          align="center"
          width="120"
          show-overflow-tooltip
          sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.productType">{{ scope.row.productType.title }}</span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
          prop="name"
          label="不良名称"
          align="center"
          min-width="110"
          show-overflow-tooltip
          sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.name">{{ scope.row.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="name"
          label="不良类别"
          align="center"
          width="120"
          show-overflow-tooltip
          sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.type">{{ scope.row.type }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column prop="type" label="可返回组装工序" align="left" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.back" :class="scope.row.back ? 'el-icon-check pass_' : ''"></span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="130px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
            <i @click="edit($event, scope.row)" class="el-icon-edit"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="是否可返回组装工序" placement="top" :open-delay="300" v-if="scope.row.code && scope.row.code.length==6">
            <i @click="editIsBack($event, scope.row)" class="el-icon-back"></i>
          </el-tooltip>
          <!-- <el-tooltip class="item" effect="dark" content="移除" placement="top" :open-delay="300">
            <i @click="del($event, scope.row)" class="iconfont icon-yichu"></i>
          </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination
        :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="search"
    ></pagination>
    <myDialog
        ref="editDialog"
        :title="dialogTitle"
        @submitData="submitData"
        @dialogClose="dialogClose"
        width="450px"
    >
      <template slot="content">
       
        <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
          <div v-if="dialogTitle == '编辑' || dialogTitle == '新增'">
            <el-form-item
            label="产品类别"
            size="small"
            prop="productType"
          >
            <el-select
              v-model="form.productType"
              placeholder="不选择产品类别则为通用"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="不良类别" size="small" prop="type">
            <el-select @change="selectTypeChange"
              v-model="form.type"
              placeholder="选择不良类别"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in qcTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="异常类别" size="small" prop="code">
              <el-cascader
                :options="qcDataTypes"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'name',
                  value: 'code',
                }"
                v-model="form.code"
                :show-all-levels="false"
                placeholder="选择所属类别"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="不良名称" size="small" prop="name">
              <el-input v-model="form.name" placeholder="不良名称" clearable></el-input>
            </el-form-item>
          </div>
          <div v-if="dialogTitle == '是否可返回组装送检前工序'">
            <el-form-item label=" " size="small" prop="back">
              <el-radio v-model="form.back" :label="true"
              >是</el-radio
            >
            <el-radio v-model="form.back" :label="false"
              >否</el-radio
            >
            </el-form-item>
          </div>
          
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiQcResultCodeAdd,
  apiQcResultCodeUpdate,
  apiQcResultCodeSearch,
  apiQcResultCodeDel,
  apiQcCodeTree,
  apiQcUpdateIsBack,
} from "@/api/plantSetting.js";
import {apiProductTypeList,} from "@/api/productModel.js";
export default {
  components: {
    pagination,
    myDialog
  },
  props: {
    searchForm: {
      type: Object
    }
  },
  data() {
    return {
      dialogTitle: '',
      tableData: [],
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      qcTypeList:[{code:"FQC",title:"FQC"},{code:"OQC",title:"OQC"}], 
      type: '',
      qcDataTypes: [],
      productTypeList:[],
      form: {},
      formRules: {
        // productType: [
        //   { required: true, message: "产品类别不能为空！", trigger: "blur" },
        // ],
        name: [
          {required: true, message: "不良名称不能为空！", trigger: "blur"},
          {
            min: 2,
            max: 32,
            message: "长度在 2 到 32 个字符",
            trigger: "change"
          }
        ],
        type: [
          {required: true, message: "不良类型不能为空！", trigger: "blur"}
        ]
      }
    };
  },
  methods: {
    // 表格数据
    async search(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiQcResultCodeSearch({
        ...this.searchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) this.callback();
      }
    },
    selectTypeChange(value){
      if(value=='FQC'){
        this.getFQCResultCode('FQC',null);
      }else if(value=='OQC'){
        this.getOQCResultCode('OQC',null);
      }
    },
    // 产品类别下拉数据
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.productTypeList = res.data;
      }
    },
    async getFQCResultCode(type,callback){ 
      const res = await apiQcCodeTree({
        showLastLevel:false,
        type:type
      });
      if (res.code == 0) {
        this.qcDataTypes = res.data;
        if (callback) callback();
      }
    },
    async getOQCResultCode(type,callback){ 
      const res = await apiQcCodeTree({
        showLastLevel:false,
        type:type
      });
      if (res.code == 0) {
        this.qcDataTypes = res.data;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({prop, order}) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.search();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.search();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.search();
    },
    openAdd() {
      this.dialogTitle = '新增';
      this.$refs.editDialog.dialogVisible = true;
    },
    edit(e, row) {
      this.dialogTitle = '编辑';
      this.$refs.editDialog.dialogVisible = true;
      this.form = {
        id: row.id,
        name: row.name,
        code: row.code
      };
    },
    editIsBack(e, row) {
      this.dialogTitle = '是否可返回组装送检前工序';
      this.$refs.editDialog.dialogVisible = true;
      this.form = {
        id: row.id,
        back: row.back
      };
    },
    // 对话框提交
    submitData() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if(this.dialogTitle == '是否可返回组装送检前工序'){
            apiQcUpdateIsBack(this.form).then(res => {
              if (res.code === 0) {
                this.$refs.editDialog.dialogVisible = false
                this.currentChange(1)
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
          }
          else if (this.form.id) {
            apiQcResultCodeUpdate(this.form).then(res => {
              if (res.code === 0) {
                this.$refs.editDialog.dialogVisible = false
                this.currentChange(1)
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
          } else {
            apiQcResultCodeAdd(this.form).then(res => {
              if (res.code === 0) {
                this.$refs.editDialog.dialogVisible = false
                this.currentChange(1)
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    del(e, row) {
      this.$confirm(`确认移除${row.name}吗？`, "QC设置移除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        apiQcResultCodeDel({
          id: row.id
        }).then(res => {
          if (res.code === 0) {
            this.currentChange(this.pagination.currentPage)
            this.$message({
              type: "success",
              message: "移除成功"
            });
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        })
      })
    },
    callback(){
        
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      val && this.$refs[ref].toggleDropDownVisible();
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.form.resetFields();
      this.form = {};
    },
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  display: flex;
  flex-direction: column;

  .refreshBox {
    /deep/ .el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .el-input {
        width: 92%;
      }

      .icon {
        font-size: 18px;
        cursor: pointer;
      }

    }
  }

}
.pass_{
        color:#67C23A;
}
</style>